import { compose, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import ggAuth from 'ggApp/modules/auth';
import { open as openModalAction } from 'ggApp/modules/modal/actions';

import { isLoggedIn as isLoggedInSelector } from 'ggApp/modules/auth/selectors';
import {
    storeActive as activeStoreSelector,
    isPartnerStore,
    currentLanguage as currentLanguageSelector,
} from 'ggApp/modules/store/selectors';
import {
    businessRequestOfferFlag,
    newReferralsHostFeatureFlag as newReferralsHostFeatureFlagSelector,
} from 'ggApp/modules/featureFlag/selectors';
import OptionsList from './OptionsList';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeLanguage: currentLanguageSelector,
            activeStore: activeStoreSelector,
            isLoggedIn: isLoggedInSelector,
            isPartner: isPartnerStore,
            requestOfferEnabled: businessRequestOfferFlag,
            newReferralsHostFeatureFlag: newReferralsHostFeatureFlagSelector,
        }),
        (dispatch) => ({
            openModal: bindActionCreators(openModalAction, dispatch),
            userActions: bindActionCreators(ggAuth.actions, dispatch),
        }),
    ),
    // eslint-disable-next-line camelcase
    withProps(
        ({
            activeStore,
            activeStore: { activeLanguage, country_code: countryCode, code },
            isLoggedIn,
        }) => ({
            faqsLink: 'https://help.grover.com/',
            authTK: isLoggedIn ? 'PROFILE_LINKS_LOG_OUT' : 'LOGGED_OUT_SIGN_IN',
            storeCode: code,
            countryCode: countryCode.toLowerCase(),
            activeLanguage,
            activeStore,
            isBusinessStore: code === 'business',
        }),
    ),
    withHandlers({
        openLoginModal: ({ openModal }) => () => {
            openModal('main-login');
        },
        logout: ({ userActions }) => () => {
            userActions.logout();
        },
    }),
);

export default enhance(OptionsList);
